import { useGetBusinessID } from '@marketing-milk/frontend'
import { BlankPageLayout } from 'components/BlankPageLayout'
import { NoItemsCreated } from 'components/NoItemsCreated/NoItemsCreated'
import { useSprint } from 'hooks/api/useSprint'
import { useFetchAllAudiences } from 'hooks/audiences/useFetchAllAudiences'
import { CampaignsContent } from 'pages/business/campaigns/components/campaign-page/CampaignContent'
import React, { useEffect } from 'react'

interface SprintsPublishedCampaignsProps {
  sprintId: number
}

export const SprintsPublishedCampaigns = (props: SprintsPublishedCampaignsProps) => {
  const businessID = useGetBusinessID()
  const { publishedCampaigns, refetchPublishedCampaigns } = useSprint(props.sprintId)
  const { audiences } = useFetchAllAudiences(businessID)

  useEffect(() => {
    refetchPublishedCampaigns()
  }, [])

  return (
    <BlankPageLayout stretch>
      {publishedCampaigns && publishedCampaigns.length > 0 ? (
        <CampaignsContent
          campaigns={publishedCampaigns}
          audiences={audiences}
          refetch={refetchPublishedCampaigns}
        />
      ) : (
        <NoItemsCreated
          title="No Published Campaigns"
          subtitle="You must complete your draft campaigns and publish them to facebook.  You can do this in the draft campaigns tab."
        />
      )}
    </BlankPageLayout>
  )
}
